import { Component, Input } from '@angular/core';

@Component({
    selector: 'cut-nav-bar',
    template: require('./navigation.html'),
    styles: [require('./navigation.scss')]
})
export class NavigationComponent {

  @Input()
  public isSolicitor: boolean;

}
